<template>
  <div class="sidebar">
    <div class="hide-btn pointer" :class="[show ? '' : 'hide']" @click="hide" />
    <ul class="sidebar-wrap" :class="[show ? '' : 'hide']">
      <li class="sidebar-item pointer" @click="gotoUser"><img src="@/assets/images/sidebar-1.png" alt="" /><span>个人中心</span></li>
      <li class="sidebar-item pointer" @click="showCsDialog"><img src="@/assets/images/znkf.png" alt="" /><span>智能客服</span></li>
      <li class="sidebar-item pointer" @click="gotoMyService"><img src="@/assets/images/wdsq.png" alt="" /><span>我的诉求</span></li>
      <li class="sidebar-item pointer">
        <el-popover placement="left" width="200" trigger="click">
          <img width="200" height="200" :src="require('@/assets/images/公众号二维码.jpg')" alt="" />
          <div slot="reference" style="display: flex; flex-direction: column; align-items: center">
            <img src="@/assets/images/sidebar-3.png" alt="" />
            <span>公众号</span>
          </div>
        </el-popover>
      </li>
      <!-- <li class="sidebar-item pointer"><img src="@/assets/images/sidebar-3.png" alt="" /><span>意见反馈</span></li>
      <li class="sidebar-item pointer"><img src="@/assets/images/sidebar-4.png" alt="" /><span>智能客服</span></li> -->
    </ul>
    <CustomerServiceDiaLog ref="CustomerServiceDiaLog" />
  </div>
</template>

<script>
import { checkLogin } from '@/utils/checkLogin'
import CustomerServiceDiaLog from '@/components/CustomerServiceDiaLog'
export default {
  name: 'GlobalSidebar',
  components: {
    CustomerServiceDiaLog,
  },
  data() {
    return {
      show: true,
    }
  },
  methods: {
    gotoMyService() {
      if (checkLogin()) {
        this.$router.push({
          path: '/user/myService',
        })
      }
    },
    gotoUser() {
      if (checkLogin()) {
        this.$router.push({
          path: '/user',
        })
      }
    },
    showCsDialog() {
      this.$refs.CustomerServiceDiaLog.showDiaLog()
    },
    hide() {
      this.show = !this.show
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .sidebar {
    // &:hover {
    //   .sidebar-wrap {
    //     // right: 5px;
    //   }
    // }
    .hide-btn {
      transition: all var(--transition-duration);
      position: fixed;
      top: 60%;
      transform: translateY(-50%);
      right: 86px;
      width: 15px;
      height: 100px;
      background-color: rgba(0, 0, 0, 0.2);
      z-index: 501;
      border-radius: 10px;
      &.hide {
        right: 0;
        &::before {
          content: '';
          width: 0;
          height: 0;
          border: 8px transparent solid;
          border-right-color: #fff;
          position: absolute;
          top: 50%;
          right: 4px;
          left: auto;
          transform: translateY(-50%);
        }
      }
      &::before {
        content: '';
        width: 0;
        height: 0;
        border: 8px transparent solid;
        border-left-color: #fff;
        position: absolute;
        top: 50%;
        left: 4px;
        transform: translateY(-50%);
      }
    }
    .sidebar-wrap {
      cursor: pointer;
      transition: all var(--transition-duration);
      width: 60px;
      min-width: 60px;
      height: 25.8333vw;
      min-height: 250px;
      background-image: linear-gradient(180deg, #f4f7ff 0%, #e6ebff 100%);
      box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      position: fixed;
      right: 0px;
      top: 60%;
      transform: translateY(-50%);
      z-index: 501;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.9194vw;
      &.hide {
        right: -120px;
      }
      .sidebar-item {
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          margin-bottom: 10px;
          width: 1.7361vw;
          min-width: 20px;
          // height: 1.7361vw;
        }
        span {
          font-size: 12px;
          color: rgba(51, 51, 51, 0.99);
          line-height: 1.1806vw;
          text-align: center;
        }
        &:not(:last-child) {
          border-bottom: 0.0694vw solid #d8e1ff;
        }
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
